import React, {ChangeEvent, useEffect} from 'react';
import {FormControlLabel, Grid, Switch} from "@material-ui/core";
import {FullWidthTextField} from "@src/Shared/styles";
import {Values} from "Tools/Values";
import {Organisation} from "@src/Interfaces/Entity/Organisation";
import {useFormik} from "formik";
import * as Yup from "yup";
import {State} from "@src/Interfaces/Entity/Person";

const validationSchema = (uniquenessValidator: () => any) => {
    return Yup.object().shape({
        name: Yup.string().required(() => {
            return Values.getLocalizationValue("fieldRequired");
        })
            .test(
                "isNameExists",
                Values.getLocalizationValue("nameAlreadyExists"),
                uniquenessValidator()
            )
    });
};

interface IOrganisationDialogForm {
    setRef: (ref: any) => void;
    initialValues: Organisation;
    onSubmit: (data: any) => void;
    uniquenessValidator: () => void;
    isEdit: boolean;
}

export const OrganisationDialogForm = (props: IOrganisationDialogForm) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            description: '',
            state: 0,
        },
        onSubmit: (data) => props.onSubmit(data),
        validationSchema: validationSchema(props.uniquenessValidator),
        validateOnChange: false,
        validateOnBlur: false
    });

    useEffect(() => {
        if (props.initialValues) {
            formik.setValues({...props.initialValues});
        }
    }, [props.initialValues]);

    const onStateChange = (checked: boolean) => {
        const state = checked ? State.Active : State.Deactivated;
        formik.setFieldValue("state", state);
    }

    return (
        <form onSubmit={formik.handleSubmit} ref={ref => props.setRef(ref)}>
            <Grid container spacing={2} direction={"column"}>
                <Grid item>
                    <FullWidthTextField
                        name={"name"}
                        onChange={formik.handleChange}
                        value={formik.values.name}
                        size={"small"}
                        error={formik.errors.name}
                        helperText={formik.errors.name}
                        label={Values.getLocalizationValue("name")}
                        variant="outlined"
                    />
                </Grid>

                {props.isEdit &&(
                    <Grid item>
                        <FullWidthTextField
                            name={"id"}
                            value={props.initialValues.id}
                            size={"small"}
                            disabled
                            label={Values.getLocalizationValue("organisationId")}
                            variant="outlined"
                        />
                    </Grid>
                )}
                
                <Grid item>
                    <FullWidthTextField
                        name={"description"}
                        onChange={formik.handleChange}
                        value={formik.values.description}
                        size={"small"}
                        error={formik.errors.description}
                        helperText={formik.errors.description}
                        label={Values.getLocalizationValue("description")}
                        variant="outlined"
                        multiline
                        rows={4}
                    />
                </Grid>

                <Grid item>
                    <FormControlLabel
                        label={Values.getLocalizationValue("active")}
                        control={
                            <Switch
                                color={"primary"}
                                name={"state"}
                                onChange={(ev) => onStateChange(ev.target.checked)}
                                checked={formik.values.state === State.Active}
                            />
                        }
                    />
                </Grid>
            </Grid>
        </form>
    );
};
